export default __webpack_public_path__ + "static/media/SidebarHelpImage.b9901216.png";